// extracted by mini-css-extract-plugin
export default {"data":"style_data__oh7Ph"};